module.exports = __webpack_public_path__ + "static/img/logo.b9032260.png";